
import React from 'react'
import CrudTable from './CrudTable'

function CrudPage(
    props
    
) {
    const endpoint = `${process.env.REACT_APP_API_URL}/api/entity/${props.entity}`
    // console.log(title);
    // console.log(props);
  return (
    <div>
      <h2>{props.title}</h2>
      <p>{props.subTitle}</p>
            <CrudTable key={props.entity}
        endpoint={endpoint}
        columns={props.allColumns}
      />
    </div>
  )
}

export default CrudPage;